var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        ref: "dialog",
        staticClass: "dialog--container",
        class: _vm.containerClasses,
        attrs: { role: "dialog", "aria-label": _vm.title, tabindex: "0" },
        on: {
          transitionend: _vm.handleContainerTransitionEnd,
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _vm.title.length
          ? _c("h3", { ref: "title" }, [_vm._v(_vm._s(_vm.title))])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "body",
            staticClass: "dialog--body",
            style: { "max-height": _vm.bodyMaxHeight },
          },
          [_vm._t("body")],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { ref: "actions", staticClass: "layout--actions dialog--actions" },
          [
            !_vm.isAlert
              ? _c(
                  "a",
                  {
                    staticClass: "dialog--deny",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.$emit("cancel")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.labelDeny))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "dialog--accept",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.$emit("submit", _vm.getDialogFormData())
                  },
                },
              },
              [_vm._v(_vm._s(_vm.labelConfirm))]
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "dialog--overlay",
      class: _vm.overlayClasses,
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.$emit("close")
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }